import { useFuzzySearchList } from '@nozbe/microfuzz/react';
import { useState } from 'react';
import useBlacklist from '@/hooks/users/use-blacklist';

export default function useFilteredBlacklist() {
  const { blacklist, isLoading, error } = useBlacklist();
  const [searchTerm, setSearchTerm] = useState('');

  const filteredBlacklist = useFuzzySearchList({
    list: blacklist,
    queryText: searchTerm,
    getText: (item) => [item.BlackUserNickName],
    mapResultItem: ({ item }) => item,
  });

  return {
    searchTerm,
    setSearchTerm,
    filteredBlacklist,
    blacklist,
    isLoading,
    error,
  };
}
